import { createI18n } from 'vue-i18n';
import en_home from './locales/en/home.json';
import pt_home from './locales/pt/home.json';
import es_home from './locales/es/home.json';
import zh_home from './locales/zh/home.json';
// Import the bar translations
import en_bar from './locales/en/bar.json';
import pt_bar from './locales/pt/bar.json';
import es_bar from './locales/es/bar.json';
import zh_bar from './locales/zh/bar.json';
// Import the business translations
import en_business from './locales/en/business.json';
import pt_business from './locales/pt/business.json';
import es_business from './locales/es/business.json';
import zh_business from './locales/zh/business.json';
// Import championships translations
import en_championships from './locales/en/championships.json';
import pt_championships from './locales/pt/championships.json';
import es_championships from './locales/es/championships.json';
import zh_championships from './locales/zh/championships.json';
// Import company translations
import en_company from './locales/en/company.json';
import pt_company from './locales/pt/company.json';
import es_company from './locales/es/company.json';
import zh_company from './locales/zh/company.json';
// Import fighter translations
import en_fighter from './locales/en/fighter.json';
import pt_fighter from './locales/pt/fighter.json';
import es_fighter from './locales/es/fighter.json';
import zh_fighter from './locales/zh/fighter.json';
// Import gym translations
import en_gym from './locales/en/gym.json';
import pt_gym from './locales/pt/gym.json';
import es_gym from './locales/es/gym.json';
import zh_gym from './locales/zh/gym.json';
// Import equipment translations
import en_equipment from './locales/en/equipment.json';
import pt_equipment from './locales/pt/equipment.json';
import es_equipment from './locales/es/equipment.json';
import zh_equipment from './locales/zh/equipment.json';
// Import sell fighter translations
import en_sellFighter from './locales/en/sellFighter.json';
import pt_sellFighter from './locales/pt/sellFighter.json';
import es_sellFighter from './locales/es/sellFighter.json';
import zh_sellFighter from './locales/zh/sellFighter.json';
// Import hospital translations
import en_hospital from './locales/en/hospital.json';
import pt_hospital from './locales/pt/hospital.json';
import es_hospital from './locales/es/hospital.json';
import zh_hospital from './locales/zh/hospital.json';
// Import auth translations
import en_auth from './locales/en/auth.json';
import pt_auth from './locales/pt/auth.json';
import es_auth from './locales/es/auth.json';
import zh_auth from './locales/zh/auth.json';
// Import profile translations
import en_profile from './locales/en/profile.json';
import pt_profile from './locales/pt/profile.json';
import es_profile from './locales/es/profile.json';
import zh_profile from './locales/zh/profile.json';
// Import pvp translations
import en_pvp from './locales/en/pvp.json';
import pt_pvp from './locales/pt/pvp.json';
import es_pvp from './locales/es/pvp.json';
import zh_pvp from './locales/zh/pvp.json';
// Import tournaments translations
import en_tournaments from './locales/en/tournaments.json';
import pt_tournaments from './locales/pt/tournaments.json';
import es_tournaments from './locales/es/tournaments.json';
import zh_tournaments from './locales/zh/tournaments.json';
// Import market translations
import en_market from './locales/en/market.json';
import pt_market from './locales/pt/market.json';
import es_market from './locales/es/market.json';
import zh_market from './locales/zh/market.json';
// Import store translations
import en_store from './locales/en/store.json';
import pt_store from './locales/pt/store.json';
import es_store from './locales/es/store.json';
import zh_store from './locales/zh/store.json';
// Import navigation translations
import en_nav from './locales/en/nav.json';
import pt_nav from './locales/pt/nav.json';
import es_nav from './locales/es/nav.json';
import zh_nav from './locales/zh/nav.json';
// Import tutorial translations
import en_tutorial from './locales/en/tutorial.json';
import pt_tutorial from './locales/pt/tutorial.json';
import es_tutorial from './locales/es/tutorial.json';
import zh_tutorial from './locales/zh/tutorial.json';
// Import recipes translations
import en_recipes from './locales/en/recipes.json';
import pt_recipes from './locales/pt/recipes.json';
import es_recipes from './locales/es/recipes.json';
import zh_recipes from './locales/zh/recipes.json';
// Import promotions translations
import en_promotions from './locales/en/promotions.json';
import pt_promotions from './locales/pt/promotions.json';
import es_promotions from './locales/es/promotions.json';
import zh_promotions from './locales/zh/promotions.json';
// Import shop translations
import en_shop from './locales/en/shop.json';
import pt_shop from './locales/pt/shop.json';
import es_shop from './locales/es/shop.json';
import zh_shop from './locales/zh/shop.json';
// Import admin translations
import en_admin from './locales/en/admin.json';
import pt_admin from './locales/pt/admin.json';
import es_admin from './locales/es/admin.json';
import zh_admin from './locales/zh/admin.json';

// Detect the user's preferred language from localStorage or use Portuguese as fallback
const getInitialLocale = () => {
  const savedLocale = localStorage.getItem('language');
  return savedLocale || 'pt';
};

const i18n = createI18n({
  legacy: false, // Enable Composition API mode
  globalInjection: true,
  locale: getInitialLocale(),
  fallbackLocale: 'pt',
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: true,
  messages: {
    en: {
      ...en_home,
      ...en_bar,
      ...en_business,
      ...en_championships,
      ...en_company,
      ...en_fighter,
      ...en_gym,
      ...en_equipment,
      ...en_sellFighter,
      ...en_hospital,
      ...en_auth,
      ...en_profile,
      ...en_pvp,
      ...en_tournaments,
      ...en_market,
      ...en_store,
      ...en_nav,
      ...en_tutorial,
      ...en_recipes,
      ...en_promotions,
      ...en_shop,
      ...en_admin
    },
    pt: {
      ...pt_home,
      ...pt_bar,
      ...pt_business,
      ...pt_championships,
      ...pt_company,
      ...pt_fighter,
      ...pt_gym,
      ...pt_equipment,
      ...pt_sellFighter,
      ...pt_hospital,
      ...pt_auth,
      ...pt_profile,
      ...pt_pvp,
      ...pt_tournaments,
      ...pt_market,
      ...pt_store,
      ...pt_nav,
      ...pt_tutorial,
      ...pt_recipes,
      ...pt_promotions,
      ...pt_shop,
      ...pt_admin
    },
    es: {
      ...es_home,
      ...es_bar,
      ...es_business,
      ...es_championships,
      ...es_company,
      ...es_fighter,
      ...es_gym,
      ...es_equipment,
      ...es_sellFighter,
      ...es_hospital,
      ...es_auth,
      ...es_profile,
      ...es_pvp,
      ...es_tournaments,
      ...es_market,
      ...es_store,
      ...es_nav,
      ...es_tutorial,
      ...es_recipes,
      ...es_promotions,
      ...es_shop,
      ...es_admin
    },
    zh: {
      ...zh_home,
      ...zh_bar,
      ...zh_business,
      ...zh_championships,
      ...zh_company,
      ...zh_fighter,
      ...zh_gym,
      ...zh_equipment,
      ...zh_sellFighter,
      ...zh_hospital,
      ...zh_auth,
      ...zh_profile,
      ...zh_pvp,
      ...zh_tournaments,
      ...zh_market,
      ...zh_store,
      ...zh_nav,
      ...zh_tutorial,
      ...zh_recipes,
      ...zh_promotions,
      ...zh_shop,
      ...zh_admin
    }
  }
});

export default i18n;
